import { DiagonalCornerModel } from '@common/models';
import { createFetchProductsHook } from '@core/utils/createFetchProductsHook';

import { useFetchDiagonalCornersQuery } from './diagonalCornersService';

type UseDiagonalCornersReturn = ReturnType<typeof _useDiagonalCorners> & {
    data?: DiagonalCornerModel[];
    diagonalCorners: DiagonalCornerModel[];
    isFetchingDiagonalCorners: boolean;
};

const emptyArray = [] satisfies DiagonalCornerModel[];

const _useDiagonalCorners = createFetchProductsHook({
    apiQueryHook: useFetchDiagonalCornersQuery,
});

export const useDiagonalCorners = (): UseDiagonalCornersReturn => {
    return _useDiagonalCorners({
        selectFromResult: (result) => {
            return {
                diagonalCorners: result.isSuccess && result.data ? result.data : emptyArray,
                isFetchingDiagonalCorners: result.isFetching,
                ...result,
            };
        },
    });
};
